export enum StatusColorEnum {
    PENDING = "#f9ce86ff", // En attente d'etre traité
    IN_PROGRESS = "#92c1b0ff", // En cours de traitement
    COMPLETED = "#47978bff", // Terminé
    WAITING_RESPONSE = "#a86ef4ff", // En attente de réponse
    ERROR = "#d7545aff" // En erreur
}